import {isDesktop} from 'app/utils';
import {APP_INSTALL_ASKED} from 'app/utils/Consts';

export const isShowAppNotification = ():boolean => !(localStorage.getItem(APP_INSTALL_ASKED) === 'true') &&
    !isDesktop() && !window.SITE_DATA.MOBILE_WRAPPER;
